import { Fragment, h } from 'preact'
import { observer } from 'mobx-react-lite'
import { useTheme, CacheProvider } from '@searchspring/snap-preact-components/dist/cjs/providers'

import './article.css';

import { BlogCard } from '../Cards/BlogCard/BlogCard';
import { TypeAheadBlogCard } from '../Cards/TypeAheadBlogCard/TypeAheadBlogCard';

export const ARTICLE_CARD_TYPES = {
    BLOG_CARD: 'BlogCard',
    TYPE_AHEAD_BLOG_CARD: 'TypeAheadBlogCard',
};

export const Article = observer((properties, controller) => {
    const globalTheme = useTheme();

    const props = {
        layout: 'grid',
        ...globalTheme?.components?.result,
        ...properties,
        ...properties.theme?.components?.result,
    }

    function ArticleCard ({ cardType }) {
        switch (cardType) {
            case ARTICLE_CARD_TYPES.BLOG_CARD:
                return <BlogCard cardProps={props} controller={properties.controller}/>; 
            case ARTICLE_CARD_TYPES.TYPE_AHEAD_BLOG_CARD:
                return <TypeAheadBlogCard cardProps={props} />;                
            default:
                return <BlogCard cardProps={props}/>;
        }
    }

    return (
        <CacheProvider>
            <ArticleCard index={props.index} cardType={props.cardType} blogRec={props.blogRec} controller={controller} />
        </CacheProvider>
    )
  }
)